module.exports = __webpack_public_path__ + "img/gartek-services-mechanical-hvac-design.0ad23df6.png";